import React from 'react';
import { css, cx } from 'react-emotion';
import { colors } from '@peachjar/components';
import InlineTip from './InlineTip';
import {
  checkHasDigit,
  checkHasLower,
  checkHasUpper,
  meetsLengthReq,
} from '../utils/index';

const { slate, jungle, gray, dragon } = colors;

const Circle = ({ color }) => (
  <div style={{ ...styles.circle, backgroundColor: color }} />
);

const PWReq = ({ meetsReq, label, isPasswordFieldFocused }) => {
  const errorColor = isPasswordFieldFocused ? 'gray' : dragon;
  const circleColor = meetsReq ? jungle : errorColor;
  return (
    <div className="row" style={styles.itemThing}>
      <Circle color={circleColor} />
      {label}
    </div>
  );
};

const PasswordRequirements = ({ isPasswordFieldFocused, pw }) => {
  const hasDigit = checkHasDigit(pw);
  const hasLower = checkHasLower(pw);
  const hasUpper = checkHasUpper(pw);
  const meetsMinLength = meetsLengthReq(pw);

  return (
    <div>
      {isPasswordFieldFocused || pw.length ? (
        <InlineTip id="password-validation">
          <div className="col-md-6" style={styles.marginVertical}>
            <PWReq
              meetsReq={meetsMinLength}
              isPasswordFieldFocused={isPasswordFieldFocused}
              label="8 character minimum"
            />
            <PWReq
              meetsReq={hasDigit}
              isPasswordFieldFocused={isPasswordFieldFocused}
              label="1 number"
            />
          </div>
          <div className="col-md-6" style={styles.marginVertical}>
            <PWReq
              meetsReq={hasLower}
              isPasswordFieldFocused={isPasswordFieldFocused}
              label="1 lowercase letter"
            />
            <PWReq
              meetsReq={hasUpper}
              isPasswordFieldFocused={isPasswordFieldFocused}
              label="1 uppercase letter"
            />
          </div>
        </InlineTip>
      ) : null}
    </div>
  );
};

const styles = {
  circle: {
    width: 8,
    height: 8,
    borderRadius: 8 / 2,
    padding: 2,
    marginLeft: 4,
    marginRight: 8,
  },
  itemThing: {
    alignItems: 'center',
    margin: 6,
    color: slate,
    fontSize: '13px',
    width: '170px',
  },
  marginVertical: {
    marginTop: 10,
    marginBottom: 10,
  },
};

export default PasswordRequirements;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff-password/components/PasswordRequirements.jsx